module.exports = __webpack_public_path__ + "static/media/Metro.9fa997d8.mp3";